
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import User from "@/interfaces/User.interface";
import UserService from "./user.service";
import { ToastFactory } from "@/utils/ToastFactory";
import useVuelidate from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";
import { getRoles } from "@/services/config";
const userService = new UserService();

const regexcpf = helpers.regex(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/);

export default defineComponent({
  name: "AddUser",
  data() {
    return {
      userId: "" as string,
      disabled: false,
      disabledButton: false,
      form: {
        user: {} as User,
      },
      roles: getRoles(),

      typeUser: [
        { name: "Administrador", code: "ADMIN", title_key: "user.fields.adm" },
        { name: "ADM IOSI", code: "ADMIN_IOSI", title_key: "user.fields.iosi" },
        { name: "Usuário", code: "USER", title_key: "user.fields.user" },
      ],

      typerUserForAdmin: [
        { name: "Administrador", code: "ADMIN", title_key: "user.fields.adm" },
        { name: "Usuário", code: "USER", title_key: "user.fields.user" },
      ],
    };
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        user: {
          name: { required },
          cpf: { required, regexcpf },
          email: { required, email },
          phone: { required },
          userType: { required },
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      storeUser: "users/getUser",
    }),
  },

  methods: {
    async getUserById() {
      userService.getUserById(this.userId).then((response) => {
        this.form.user = this.storeUser;
      });
    },

    async addNewUser(data: User): Promise<any> {
      await userService
        .addUser(data)
        .then(() => {
          this.$router.push({ name: "Users" });
          this.$toast.add(ToastFactory.success(this.$t("toast.sucessUser")));
          this.disabledButton = false;
        })
        .catch((e) => {
          console.log("error", e);
          this.$toast.add(ToastFactory.error(this.$t("toast.errorUser")));
          this.disabledButton = false;
        });
    },

    async updateUser(data: User): Promise<any> {
      const newData = {
        cpf: data.cpf,
        email: data.email,
        name: data.name,
        phone: data.phone,
        type: data.type,
        userId: data.userId,
      };
      await userService
        .updateUser(this.userId, newData)
        .then(() => {
          this.$router.push({ name: "Users" });
          this.$toast.add(
            ToastFactory.success(this.$t("toast.sucessUserEdit"))
          );
          this.disabledButton = false;
        })
        .catch((e) => {
          console.log("error", e);
          this.$toast.add(ToastFactory.error(this.$t("toast.errorUserDelete")));
          this.disabledButton = false;
        });
    },

    sendUser(): void {
      this.form.user.cpf = this.form.user.cpf.replace(/\D/g, "");
      this.form.user.phone = this.form.user.phone.replace(/\D/g, "");
      this.form.user.userType = this.form.user.type
      this.v$.form.$touch();
      if (this.v$.form.$error) {
        this.disabledButton = true;
        this.userId
          ? this.updateUser(this.form.user)
          : this.addNewUser(this.form.user);
      }
    },
  },

  mounted() {
    this.userId = this.$route?.params?.id as string;
    this.userId ? this.getUserById() : null;
  },
});
